import styled from 'styled-components';

export const Container = styled.div`
  width: 700px;
  margin: 0 auto;
  @media (max-width: 991px) {
    width: auto;
  }
`;
export const Title = styled.h1`
  font-weight: 700;
  font-size: 30px;
  line-height: 36px;
  letter-spacing: 0px;
  margin: 25px 0 0;
  text-align: center;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
`;
export const MainInfoContent = styled.div`
  background: #ffffffcc;
  border-top: 1px solid #e2e8f0;
  border-radius: 24px;
  box-shadow: 0px 8px 10px -6px #0000001a;
  box-shadow: 0px 20px 25px -5px #0000001a;
  padding: 33px;
  @media (max-width: 767px) {
    padding: 16px;
  }
`;
export const SubTitle = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  color: #6c757d;
  text-align: center;
  margin-bottom: 16px;
`;
export const CompetitorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding-bottom: 100px;
  @media (max-width: 991px) {
    grid-template-columns: 1fr;
  }
`;

export const CompetitorCard = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  position: relative;
  min-width: 0;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
`;

export const LogoWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  @media (max-width: 520px) {
    width: 40px;
    height: 40px;
  }
  @media (max-width: 440px) {
    margin-right: 8px;
  }
`;

export const CompetitorName = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #1d293d;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  @media (max-width: 520px) {
    font-size: 16px;
  }
`;

export const CompetitorType = styled.span`
  font-size: 14px;
  color: #62748e;
  font-weight: 500;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  @media (max-width: 520px) {
    font-size: 12px;
  }
`;

export const CheckboxWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 14px;
  border: 2px solid ${(props) => (props.isActive ? '#2d6cdf' : '#cad5e2')};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  background: ${(props) => (props.isActive ? 'transparent' : 'transparent')};
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;
  @media (max-width: 520px) {
    width: 25px;
    height: 25px;
  }
`;

export const CheckIcon = styled.svg`
  width: 30px;
  height: 30px;
  fill: #2d6cdf;
  display: flex;
  @media (max-width: 520px) {
    width: 15px;
    height: 15px;
  }
`;

export const LoadingSpinner = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #6c757d;
  font-size: 16px;
  font-weight: 500;
`;

export const FlexContainer = styled.div`
  flex: 1;
`;
